export enum InvoiceStatus {
  DRAFT = 'DRAFT',
  PROFORMA = 'PROFORMA',
  BILLED = 'BILLED',
  PAID = 'PAID',
  NOT_PAID = 'NOT_PAID',
  COLLECTED = 'COLLECTED',
}
